// saves the controls state to session storage
export function saveControlState($ctrl: JQuery, statekey: string) {
    const myStorage = window.sessionStorage;
    myStorage.setItem(statekey, <string> $ctrl.val());
}

// Clear session storage for the control's state
export function clearControlState(statekey: string) {
    const myStorage = window.sessionStorage;
    myStorage.removeItem(statekey);
}

// Load the control state from session storage
export function loadControlState($ctrl: JQuery, statekey: string): boolean {
    const myStorage = window.sessionStorage;
    const saveval = myStorage.getItem(statekey);
    if (saveval) {
        $ctrl.val(saveval);
        return true;
    } else {
        return false;
    }
}
